import React from 'react';
import { defineCommand } from '../../../../../concepts/commands/CommandDefinition';
import { Camera } from '../../../../canvas/Camera';
import { EditorSession } from '../../../../canvas/EditorSession';
import { Selection } from '../../../../canvas/Selection';
import { SpatialIndex } from '../../../../canvas/utilities/SpatialIndex';
import { Copy, Flexer } from '../../../../dashboard/elements/LayoutElements';
import { useAssitantToolCallResult } from '../../AssistantHooks';
import { AssitantToolSupport } from '../../AssistantToolSupport';
import { ToolCallPart } from '../../ChatTypes';

const GetObjectsToolCallView = React.memo(({ toolCallId }: ToolCallPart) => {

    const result = useAssitantToolCallResult(toolCallId);
    const length = Array.isArray(result) ? result.length : 0;

    return <Flexer padding=".5">
        <Copy flush>
            {!result && <>Reading the board...</>}
            {result && <>Read {length} objects from the board.</>}
        </Copy>
    </Flexer>;
});

export const GetObjectsToolSupport = AssitantToolSupport({
    toolName: 'getObjects',
    ui: GetObjectsToolCallView,
    command: defineCommand(
        'assitantGetObjects',
        null,
        cc => {

            const camera = cc.resolve(Camera);
            const spatial = cc.resolve(SpatialIndex);

            const selection = cc.resolve(EditorSession).get(Selection);
            const elmts = selection.size > 0
                ? selection.toArray()
                : Array.from(spatial.lookup(camera.getModelFrame()));

            return elmts.map(x => x.toJson());
        }
    )
});
